module.exports = __webpack_public_path__ + "img/consumption_disable.cddd4e8b.png";